import React, {Fragment, useEffect, useState} from 'react';
import {Transition} from '@headlessui/react';
import notificationService from '../../services/notification.service';
import {ListenerNotify, Notification, Notifications} from '../../models/interfaces/notification.interface';
import SuccessNotification from './success-notification';
import ErrorNotification from './error-notification';
import WarningNotification from './warning-notification';
import InfoNotification from './info-notification';
import {classNames} from "@utils/class-names";

const NotificationPrompt: React.FC = () => {
    const [notifications, setNotifications] = useState<Notification[]>([]);

    useEffect(() => {
        const handleNotifications: ListenerNotify = (notifications: Notification[]): void => {
            setNotifications([...notifications]);
        };

        notificationService.addListener(handleNotifications);

        return (): void => {
            notificationService.removeListener(handleNotifications);
        };
    }, []);

    const closeNotification = (notification: Notification): void => {
        notificationService.remove(notification);
    };

    const renderNotificationComponent = (notification: Notification) => {
        switch (notification.type) {
            case Notifications.SUCCESS:
                return <SuccessNotification notification={notification}
                                            onClose={() => closeNotification(notification)}/>;
            case Notifications.ERROR:
                return <ErrorNotification notification={notification} onClose={() => closeNotification(notification)}/>;
            case Notifications.WARNING:
                return <WarningNotification notification={notification}
                                            onClose={() => closeNotification(notification)}/>;
            case Notifications.INFO:
            default:
                return <InfoNotification notification={notification} onClose={() => closeNotification(notification)}/>;
        }
    };

    return (
        <div className={classNames(
            'fixed space-y-2 min-w-[250px] sm:w-fit w-full z-50',
            'bottom-12 left-1/2 -translate-x-1/2 px-4'
        )}>
            {notifications.map((notification: Notification) => (
                <Transition
                    key={notification.id}
                    show={true}
                    as={Fragment}
                    appear={true}
                    enter="transform transition duration-300"
                    enterFrom="translate-y-[300%]"
                    enterTo="translate-y-0"
                    leave="transform transition duration-300"
                    leaveFrom="translate-y-0"
                    leaveTo="translate-y-[300%]"
                >
                    <div>{renderNotificationComponent(notification)}</div>
                </Transition>
            ))}
        </div>
    );
};

export default NotificationPrompt;
